module.exports = __webpack_public_path__ + "static/regency-ab258d103b9445fd093857744fd91f0e.jpg";